module.exports = __webpack_public_path__ + "static/media/SFProDisplay-Medium.70830fa4.ttf";